import React, { Component } from "react";
import ReactSVG from "react-svg";
import { Item } from "@outplayed/tooltips";
import { getIcon } from "@outplayed/riot-assets";
import classNames from "classnames";

export default class ItemTimeline extends Component {
  stackDuplicateItems(visit) {
    return visit.reduce((acc, cur, index) => {
      const dupeIndex = acc.findIndex((item) => cur.itemId === item.itemId);
      if (dupeIndex < 0) {
        // New item to list
        cur.count = 1;
        acc.push({ ...cur });
      } else {
        // Update count and latest timestamp
        if (acc[dupeIndex].sold === cur.sold) {
          acc[dupeIndex].count++;
          acc[dupeIndex].timestamp = cur.timestamp;
        } else {
          cur.count = 1;
          acc.push({ ...cur });
        }
      }

      return acc;
    }, []);
  }

  formatItemPath() {
    // let minute = 0;
    let visit = {
      time: 0,
      items: [],
    };
    let path = [];

    this.props.items.forEach((item, index) => {
      const time = Math.trunc(item[1] / 60000);
      const itemObj = {
        itemId: item[0],
        timestamp: item[1],
        sold: Number(item[2]) === 2,
      };

      if (path.length === 0 && visit.items.length === 0) {
        visit.time = time;
        visit.items.push(itemObj);
        return;
      }

      if (visit.time === time) {
        visit.items.push(itemObj);
      } else {
        visit.items = this.stackDuplicateItems(visit.items);
        path.push(visit);
        visit = {
          time,
          items: [itemObj],
        };
      }

      if (index === this.props.items.length - 1) {
        visit.items = this.stackDuplicateItems(visit.items);
        path.push(visit);
      }
    });

    return path;
  }

  buildPath(items, patch, spriteSize, winConditionClass) {
    const timeline = items.map((itemsPerVisit, index) => {
      const time = itemsPerVisit.time;

      let visits = itemsPerVisit.items.map((item, index2) => {
        return (
          <div key={`${index}-${index2}`}>
            <div className="item-purchased">
              <Item
                className="sprite"
                style={{ width: "100%", borderRadius: "15%" }}
                itemId={item.itemId}
                spriteSize={spriteSize}
                isSprite
                patch={patch}
                disableTooltip={this.props.disableTooltip}
              />
              {item.count > 1 && <div className="item-count">{item.count}</div>}
              {item.sold && (
                <div className="item-sold">
                  <ReactSVG wrapperClassName="react-svg item-sold-img" path={getIcon("ugg/icons/x.svg")} />
                </div>
              )}
            </div>
          </div>
        );
      });

      return (
        <div key={index} className="items-purchased-wrapper">
          <div style={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
            <div className={classNames("items-purchased-by-minute", winConditionClass)}>{visits}</div>
            <div className="timestamp">{`${time} min`}</div>
          </div>
          {index === items.length - 1 ? null : <div className={classNames("separator", winConditionClass)}></div>}
        </div>
      );
    });

    return timeline;
  }

  render() {
    const { patch, spriteSize, winConditionClass } = this.props;
    return <div style={{ marginBottom: -5 }}>{this.buildPath(this.formatItemPath(), patch, spriteSize, winConditionClass)}</div>;
  }
}
